module.exports = "https://redage.akamaized.net/src/views/player/documets/msc/images/logo.png";